<template>
  <div class="page page--login" data-page="login">
    <TopBackVue back="/"></TopBackVue>

    <div class="login">
      <div class="login__content">
        <h2 class="login__title">Create an account</h2>
        <div class="login-form">
          <form id="LoginForm" method="post" @submit.prevent="signup">
            <div class="login-form__row">
              <label class="login-form__label">User ID</label>
              <input
                v-model="user_id"
                type="text"
                name="user_id"
                class="login-form__input required"
              />
            </div>
            <div class="login-form__row">
              <label class="login-form__label">Username</label>
              <input
                v-model="username"
                type="text"
                name="username"
                class="login-form__input required"
              />
            </div>
            <div class="login-form__row">
              <label class="login-form__label">Email</label>
              <input
                v-model="email"
                type="email"
                name="email"
                class="login-form__input required email"
              />
            </div>
            <div class="login-form__row">
              <label class="login-form__label">Password</label>
              <input
                v-model="password"
                type="password"
                name="password"
                class="login-form__input required"
              />
            </div>
            <div class="login-form__row">
              <input
                id="submit"
                type="submit"
                name="submit"
                class="login-form__submit button button--main button--full"
                value="SIGN UP"
                :disabled="isDisabled"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import TopBackVue from "@/components/templates/inc/TopBack.vue";
import Swal from "sweetalert2";
import { useRouter } from "vue-router";
import axios from "axios";

const router = useRouter();
const isDisabled = ref(false);

const user_id = ref("");
const username = ref("");
const email = ref("");
const password = ref("");

const requestCheck = async (form) => {
  if (form.user_id && form.username && form.email && form.password) {
    return true;
  }

  await Swal.fire({
    icon: "error",
    title: "입력 확인",
    text: "모든 항목을 입력해 주세요.",
    confirmButtonText: "확인",
  });
  return false;
};

const signup = async () => {
  if (isDisabled.value) return;

  const form = {
    user_id: user_id.value.trim(),
    username: username.value.trim(),
    email: email.value.trim(),
    password: password.value,
  };

  if (!(await requestCheck(form))) return;

  isDisabled.value = true;

  try {
    const { data } = await axios.post("/api/tron/create_account", form);

    if (data?.result === "success") {
      await Swal.fire({
        icon: "success",
        title: "회원가입 완료",
        text: "회원가입이 완료되었습니다. 로그인해 주세요.",
        confirmButtonText: "확인",
      });
      await router.push({ name: "login" });
      return;
    }

    if (data === "exist" || data?.result === "exist") {
      await Swal.fire({
        icon: "error",
        title: "회원가입 실패",
        text: "이미 사용 중인 아이디 또는 이메일입니다.",
        confirmButtonText: "확인",
      });
      return;
    }

    throw new Error(data?.message || "회원가입에 실패했습니다.");
  } catch (error) {
    console.error("Signup failed:", error);
    await Swal.fire({
      icon: "error",
      title: "회원가입 실패",
      text: error.response?.data?.message || error.message,
      confirmButtonText: "확인",
    });
  } finally {
    isDisabled.value = false;
  }
};
</script>

<style lang="scss" scoped></style>
